import { Link } from 'gatsby'
import React from 'react'

const Toc = () => (
  <section>
    <h1>Indhold</h1>
    <p>
      <Link to="/predictive-poem/">Predictive Poem</Link> / Johanne Østervang
    </p>
    <p>
      <Link to="/mono/">Mono</Link> / Amdi Silvestri
    </p>
    <p>
      <em>---- flere på vej ----</em>
    </p>
  </section>
)

export default Toc
